import HostMatcher from './-private/host-matcher';
import { warn } from '@ember/debug';

// TODO(qvu): This is identical to api-urls save for the prefix. Refactor needed

// Mappings of Square domains to CONNECT sub-domains.
//
// TODO: while most of the entries in this array are general to Square,
// consumers may want to configure or add to this array (evidenced by the
// presence of one Dashboard specific mapping here).
const HOST_MATCHERS = [new HostMatcher(/^(.+\.)*squareup.com$/, () => {
  return 'connect.squareup.com';
}), new HostMatcher(/^(.+\.)*squareupsandbox.com$/, () => {
  return 'connect.squareupsandbox.com';
}), new HostMatcher(/^(.+\.)*squareupstaging.com$/, () => {
  return 'connect.squareupstaging.com';
}), new HostMatcher(/^(.+\.)*squareup.com.([^.]+\.local)$/, match => {
  return `connect.squareup.com.${match[2]}`;
}), new HostMatcher(/^localhost:(\d+)$/, match => `localhost:${match[1]}`)];
/**
 * Determines the CONNECT sub-domain for a given domain.
 *
 * This function allows easily configuring an CONNECT call to be sent to
 * the CONNECT sub-domain. For example:
 *
 * - `connect.squareup.com` instead of `squareup.com`
 *
 * @param {string} host
 * @returns {string} The CONNECT sub-domain
 */
export function connectHost(host, options) {
  if (options?.useSameHost) {
    return host;
  }
  for (const hostMatcher of HOST_MATCHERS) {
    const match = hostMatcher.match(host);
    if (match) {
      return match;
    }
  }
  warn(`cannot determine CONNECT host for host: ${host}`, false, {
    id: 'connectHost'
  });
  return host;
}